import React from 'react';

const Home = () => (
  <div className="home">
    <h2>Welcome to our page</h2>
    <p>
      Maths is generally defined as the science of numbers and the operations performed among them.
      It deals with both alphabets along with numbers and involves addition, subtraction,
      multiplication, division, comparison, etc. It is used in every field. Maths consists of
      finding a relation between numbers, calculating the distance between two places, counting
      money, calculating profit and loss.
    </p>
    <p>
      It is of two types pure and applied. Pure math deals with the basic structure and concept of
      maths, whereas applied mathematics deals with how maths is used it involves the application of
      maths in our daily life. All the subjects include maths, and hence maths is considered to be
      one of the primary and joint issues which need to be learned by everyone. One couldn’t imagine
      their life using maths. It has made our experience easy and straightforward. It has prevented
      chaos in our daily life. Hence learning maths is mandatory for everyone.
    </p>
  </div>
);

export default Home;
